import AboutModal from './AboutModal.json';
import Buttons from './Buttons.json';
import CineDialog from './CineDialog.json';
import Common from './Common.json';
import DataRow from './DataRow.json';
import DataSourceConfiguration from './DataSourceConfiguration.json';
import DatePicker from './DatePicker.json';
import ErrorBoundary from './ErrorBoundary.json';
import Header from './Header.json';
import HotkeysValidators from './HotkeysValidators.json';
import InvestigationalUseDialog from './InvestigationalUseDialog.json';
import MeasurementTable from './MeasurementTable.json';
import Messages from './Messages.json';
import Modes from './Modes.json';
import SegmentationPanel from './SegmentationPanel.json';
import SidePanel from './SidePanel.json';
import StudyBrowser from './StudyBrowser.json';
import StudyItem from './StudyItem.json';
import StudyList from './StudyList.json';
import ThumbnailTracked from './ThumbnailTracked.json';
import TooltipClipboard from './TooltipClipboard.json';
import TrackedCornerstoneViewport from './TrackedCornerstoneViewport.json';
import UserPreferencesModal from './UserPreferencesModal.json';
import ViewportDownloadForm from './ViewportDownloadForm.json';
import WindowLevelActionMenu from './WindowLevelActionMenu.json';

export default { 
  'ru': {
    AboutModal,
    Buttons,
    CineDialog,
    Common,
    DataRow,
    DataSourceConfiguration,
    DatePicker,
    ErrorBoundary,
    Header,
    HotkeysValidators,
    InvestigationalUseDialog,
    MeasurementTable,
    Messages,
    Modes,
    SegmentationPanel,
    SidePanel,
    StudyBrowser,
    StudyItem,
    StudyList,
    ThumbnailTracked,
    TooltipClipboard,
    TrackedCornerstoneViewport,
    UserPreferencesModal,
    ViewportDownloadForm,
    WindowLevelActionMenu,
  }
};
